const SESSION_KEY = 'colibri_admin_session'
const SESSION_TTL_MS = 2 * 60 * 60 * 1000 // 2 horas, debe coincidir con AUTH_TOKEN_TTL_SECONDS del backend

export const startAdminSession = (username, token) => {
  sessionStorage.setItem(
    SESSION_KEY,
    JSON.stringify({ username, token, loginAt: Date.now() })
  )
}

export const endAdminSession = () => {
  sessionStorage.removeItem(SESSION_KEY)
}

const readSession = () => {
  const raw = sessionStorage.getItem(SESSION_KEY)
  if (!raw) return null

  try {
    return JSON.parse(raw)
  } catch {
    endAdminSession()
    return null
  }
}

export const hasActiveAdminSession = () => {
  const session = readSession()
  if (!session?.token || !session?.loginAt) return false

  if (Date.now() - session.loginAt > SESSION_TTL_MS) {
    endAdminSession()
    return false
  }

  return true
}

export const getAdminToken = () => {
  const session = readSession()
  return session?.token || null
}
